import React from "react";
import { useState,useEffect } from "react";
import { useLocation,useNavigate,useSearchParams, useParams  } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/FlatShippingRates.css';
import { configData } from "../config";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";


const FlatShippingRates = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const { id } = useParams(); 
    const location = useLocation();
    const loggedin_uid = localStorage.getItem('drupal_uid');

    const [isLoading, setIsLoading] = useState(true);
     const [continentlist, setContinentList] = useState([]);
     const [shipmentratelist, setShipmentRateList] = useState([]);
 const[success,setSuccess] = useState('');
    const [formData, setFormData] = useState ({
        rates: []
    });

    const handleRateChange = (id, value) => {
       
        setFormData(prev => ({
            ...prev,
            rates: {
            ...prev.rates,
            [id]: value,
            },
        }));
    };

    useEffect(() => { 
        Promise.all([
            getcontinentlist(),
            getshipmentratelist()
            ]).then(() => {
     
                setIsLoading(false);
                console.log(formData);
            })   
    },[]); 

   
    const handleSubmit = async (e) => {
        e.preventDefault();

       const postData = formData;
      const response = await fetch(app_url + 'shippingrates/putshippingrates', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
               setSuccess(data.data.result);
               window.scrollTo(0, 0);
        }
       
    };
    async function getcontinentlist() {
   
         try {
            const response = await fetch(
                app_url+'shippingrates/getshipmentcontinentlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setContinentList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
       
  }
  async function getshipmentratelist() {
   
         try {
            const response = await fetch(
                app_url+'shippingrates/getshipmentratelist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setShipmentRateList(responsedata.data.result);
                 setFormData({rates:responsedata.data.rates});
                 console.log(formData);
               
            } 
        } catch (err) {
            
         }
       
  }
  
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main">
                    <Helmet><title>Add Shipping Rates</title></Helmet>
                    <div className="left"></div>
                    <div className="left-center">
                        <div class="flat-shipping-rates-container">
                            <div className="add_shipping_rates">
                                <div className="shipping_details">
                                      {success && (
          <>
          <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
          </div></>
          
        )}
                                    <h2>Flat Shipping Rates</h2>
                                    <div className="messages_details">
                                        <ul>
                                            <li>If "Flat Shipping Rate" is blank, then that service won't show at checkout for that region.</li>
                                            <li>
                                                <a 
                                                    href="https://docs.google.com/spreadsheets/d/1HvmiQ2zv-dDbP0LI0pjFsLUuYBpelhnbBIq8642bmME/edit?usp=sharing" 
                                                    target="_blank" rel="noopener noreferrer" style={{cursor: "pointer",color:"#2c99d2"}}
                                                >
                                                    Click here to view the countries for each region
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div>
                                            {continentlist.map(({ key, title }) => (
                                                <div key={key}>
                                                <div className="country_name">{title}</div>
                                                <table>
                                                    <thead>
                                                    <tr>
                                                        <th>Service</th>
                                                        <th>Estimated Arrival</th>
                                                        <th>Flat Shipping Rate</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {shipmentratelist[key].map((row, idx) => {
  const rateKey = row.id;
 const rateValue = formData.rates[rateKey] ?? row.rates ?? '';
  return (
    <tr key={idx}>
      <td className="first_col">{row.service}</td>
      <td className="second_col">{row.estimated_arrival}</td>
      <td className="third_col">
        $ <input 
          name="rates" 
          type="number" 
          step="any" 
          value={rateValue} 
          onChange={(e) => handleRateChange(row.id, e.target.value)} 
        />
      </td>
    </tr>
  );
})}


                                                    </tbody>
                                                </table>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="buttons" style={{margin:"0 auto", textAlign: "center"}}>
                                            <a href="/add-shipping-rates">
                                                <input
                                                    type="button"
                                                    name="cancel"
                                                    value="Cancel"
                                                />
                                            </a>
                                                <input type="submit" name="submit" value="Save" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default FlatShippingRates;